import { render, staticRenderFns } from "./ChangeInitialPasswordPage.vue?vue&type=template&id=e8486776"
import script from "./ChangeInitialPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ChangeInitialPasswordPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8486776')) {
      api.createRecord('e8486776', component.options)
    } else {
      api.reload('e8486776', component.options)
    }
    module.hot.accept("./ChangeInitialPasswordPage.vue?vue&type=template&id=e8486776", function () {
      api.rerender('e8486776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/change-initial-password/ChangeInitialPasswordPage.vue"
export default component.exports